'use client'
import { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import { notify } from './bugsnag/bugsnag.client'
import { useNavigate } from './(client)/hooks/useNavigate'

const NotFound = () => {
  const pathName = usePathname()
  const router = useNavigate()

  useEffect(() => {
    notify({ name: 'PageNotFound', message: `Path is not valid: ${pathName}` })
    router.replace('/')
  }, [pathName, router])

  return null
}

export default NotFound
